export default __webpack_public_path__ + "4b513b8070bf8ada811b36f54f912665.png";